<div
  class="mat-form-field-container lib-select-container"
  #mffContainer
  [class.theme-dark]="theme === 'dark'"
  [ngClass]="{ disabled }"
>
  <mat-form-field
    [hideRequiredMarker]="true"
    appearance="fill"
    class="select-primary"
    [floatLabel]="myFloatLabel && myFloatLabel !== 'never' ? myFloatLabel : 'auto'"
    [ngClass]="{
      'select-open': select.panelOpen,
      'no-infix': noInfix,
      'no-underline': noUnderline,
      'no-background': noBackground,
      'with-label': label,
      'truncate-value': truncateValue,
    }"
  >
    @if (label) {
      <mat-label>
        <span [class.required-label]="requiredInLabel || required">{{
          translateLabel ? (label | transloco) : label
        }}</span>
      </mat-label>
    }
    <span
      class="select-arrow"
      [inlineSVG]="
        (dropdownIconsPath ? dropdownIconsPath : '/icons/icon-arrow-') + (select.panelOpen ? 'up' : 'down') + '.svg'
      "
    ></span>
    @if (sortMode) {
      <span
        (click)="changeSortMode($event)"
        class="sort-icon cta-btn"
        [ngClass]="{ ascending: isSortAscending }"
        [inlineSVG]="'/icons/icon-sort.svg'"
      ></span>
    }
    <mat-select
      [required]="required"
      [disabled]="disabled"
      #select
      (openedChange)="onOpenedChange($event)"
      [(ngModel)]="value"
      disableOptionCentering
      [ngClass]="{ 'offset-left': offsetToLeft, 'sort-mode': sortMode }"
      [panelClass]="'select-options-primary ' + customPanelClass"
      [placeholder]="placeholder | transloco"
      (selectionChange)="onValueChange($event, false, select)"
    >
      @if (withTrigger) {
        <mat-select-trigger>
          <ng-content></ng-content>
        </mat-select-trigger>
      }
      @if (groups) {
        @for (group of $any(groups) | keyvalue: unsorted; track group) {
          @if (group.value.length > 0) {
            <mat-optgroup [label]="group.key | transloco">
              <ng-container *ngTemplateOutlet="matOptions; context: { options: group.value }"></ng-container>
            </mat-optgroup>
          }
        }
      }
      @if (!groups) {
        <ng-container *ngTemplateOutlet="matOptions; context: { options: options }"></ng-container>
      }

      <ng-template #matOptions let-options="options">
        @for (option of options; track option) {
          <mat-option
            [class.hidden]="option.hidden"
            (click)="stayOpenAfterPick && select.open()"
            [value]="option.value"
            [style.width.px]="optionWidth"
            (onSelectionChange)="onOptionToggle($event, option)"
          >
            <div style="display: flex; align-items: center; gap: 8px">
              @if (selectedIds !== null) {
                <mat-checkbox
                  class="checkbox checkbox-bg option-checkbox"
                  [checked]="selectedIds.includes(option.value)"
                  [disableRipple]="true"
                  style="pointer-events: none; max-width: 48px; flex-shrink: 0"
                ></mat-checkbox>
              }
              @if (option.img) {
                <img class="img-option" [style.width]="optionImgWidth" [src]="option.img" />
              }
              @if (translation) {
                {{ (translationPrefix ? translationPrefix + option.key : option.key) | transloco }}
              } @else {
                {{ option.key }}
              }
            </div>
          </mat-option>
        }
      </ng-template>
    </mat-select>
    @if (errors) {
      <div class="mat-error">
        @if (errors.required) {
          {{ 'form.error.required' | transloco }}
        }
      </div>
    }
  </mat-form-field>
</div>
